import styled from '@emotion/styled';
import React from 'react';
import { typography } from '../../styles/typography';

export interface IProps
  extends React.HTMLAttributes<HTMLTableHeaderCellElement> {
  align?: 'left' | 'center' | 'right' | 'justify' | 'char';
  children?: React.ReactNode;
  [key: string]: any;
}

const Host = styled.th<{ align?: string }>`
  padding: 12px 10px 5px;
  ${typography.bodySmall}
  text-align: ${(props) => (props.align ? props.align : 'left')};
  border-bottom: ${(props) => `3px solid ${props.theme.shades.primary5}`};

  &:first-child {
    ${typography.h5}
  }
`;

export const Th = ({ align, children, ...rest }: IProps) => {
  return (
    <Host align={align} {...rest}>
      {children}
    </Host>
  );
};
